import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import HomeWorkIcon from "@material-ui/icons/HomeWork";
import { useChatHighlight } from "../../context/ChatHighlight/ChatHighlightContext";
import { i18n } from "../../translate/i18n";

// Banner global de MatchProp. Derivado 100% del ChatHighlightContext (feat_116):
// busca el highlight type "matchprop" (chat "🔔 Alertas Propiedades") y muestra
// UN banner agregado con el contador `pending`. Se DESAPARECE solo cuando el
// highlight se limpia (= al entrar al chat → clearForTicket → socket clear).
// No spamea: es un único banner-contador, no uno por match. Multi-tenant: el
// contexto ya está scopeado a la empresa del usuario.
const useStyles = makeStyles((theme) => ({
  banner: {
    width: "100%",
    boxSizing: "border-box",
    background: "#00c853",
    color: "#fff",
    padding: theme.spacing(1, 2),
    display: "flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
    fontWeight: 700,
    fontSize: 14,
    boxShadow: "inset 0 -2px 0 rgba(0,0,0,0.15)",
  },
}));

const MatchPropBanner = () => {
  const classes = useStyles();
  const history = useHistory();
  const { highlights } = useChatHighlight();

  // Buscar el highlight matchprop (uno por empresa: el chat de alertas).
  let ticketId = null;
  let count = 0;
  Object.entries(highlights || {}).forEach(([tid, h]) => {
    if (h && h.type === "matchprop") {
      ticketId = Number(tid);
      const p = (h.payload && h.payload.pending) || (h.payload && h.payload.count) || 1;
      count = typeof p === "number" ? p : 1;
    }
  });

  if (!ticketId || count < 1) return null;

  return (
    <div
      className={classes.banner}
      onClick={() => history.push(`/tickets/${ticketId}`)}
      title={i18n.t("matchpropBanner.goToChat")}
    >
      <HomeWorkIcon fontSize="small" />
      <span>🏠 {i18n.t("matchpropBanner.text", { count })}</span>
    </div>
  );
};

export default MatchPropBanner;
